import { z } from 'zod';

export const UTM_SESSION_STORAGE_KEY = 'hr_utm_data';

export const UTM_PARAMS = {
  campaign: 'utm_campaign',
  medium: 'utm_medium',
  source: 'utm_source',
  term: 'utm_term',
  content: 'utm_content',
} as const;

export const UtmData = z.object({
  campaign: z.string().nullable(),
  source: z.string().nullable(),
  medium: z.string().nullable(),
  term: z.string().nullable(),
  content: z.string().nullable(),
});

export type UtmDataType = z.infer<typeof UtmData>;

export const REFERRAL_SESSION_STORAGE_KEY = 'hr_referral_data';

/**
 * URL params a referral link carries. They are read at the landing page and
 * persisted to session storage so they survive the journey to signup, where
 * they are attached to the `Completed Registration` event.
 */
export const REFERRAL_PARAMS = {
  referral_source: 'referral_source',
  referral_cookbook_user_id: 'referral_cookbook_user_id',
  referral_link_id: 'referral_link_id',
} as const;

export const REFERRAL_SOURCES = [
  'cookbook_share',
  'organic',
  'paid',
  'email',
  'other',
] as const;

export const ReferralSource = z.enum(REFERRAL_SOURCES);
export type ReferralSourceType = z.infer<typeof ReferralSource>;

export const ReferralData = z.object({
  referral_source: ReferralSource.nullable(),
  referral_cookbook_user_id: z.string().nullable(),
  referral_link_id: z.string().nullable(),
});

export type ReferralDataType = z.infer<typeof ReferralData>;
